module.exports = "/static/media/print_icon.96f555b7.svg";